import { useToastStore } from '../../stores/toast'

const kindClasses = {
    success: 'border-green-500 bg-green-50 dark:bg-green-950/60 text-green-800 dark:text-green-200',
    error: 'border-red-500 bg-red-50 dark:bg-red-950/60 text-red-800',
    info: 'border-blue-500 bg-blue-50 dark:bg-blue-950/60 text-blue-800 dark:text-blue-200',
}

export function Toaster() {
    const toasts = useToastStore(s => s.toasts)
    const dismiss = useToastStore(s => s.dismiss)

    return (
        <div className='fixed right-4 bottom-4 z-[60] flex w-80 flex-col gap-2'>
            {toasts.map(t => (
                <button
                    key={t.id}
                    onClick={() => dismiss(t.id)}
                    className={`rounded-lg border-l-4 px-4 py-3 text-left text-sm shadow-md transition-opacity ${kindClasses[t.kind]}`}
                >
                    {t.message}
                </button>
            ))}
        </div>
    )
}
